<template>
    <v-dialog
        v-model="dialog"
        width="380px"
        persistent
    >
        <sign-in @loginSuccess="loginSuccess"/>
    </v-dialog>
</template>

<script>
import signIn from "@/component/signIn/signIn";
import { eventBus } from "@/script/global-emit/eventBus";

export default {
    name: "signInDialog",
    components: {
        signIn
    },
    created() {
        eventBus.$on("status401", () => {
            this.dialog = true
        });
    },
    data() {
        return {
            dialog: false
        }
    },
    methods: {
        loginSuccess() {
            this.dialog=false
            if (this.$store.state.onAuth && this.$store.state.PersonCode) {
                this.$store.state.onAuth.forEach((item)=> {
                    if(item && typeof item ===  typeof(()=>{})) {
                        item(this.$store.state.PersonCode)
                    }
                })
                this.$store.state.onAuth = []
            }
        }
    }
}
</script>

<style scoped>

</style>
